import styled, { css } from 'styled-components'
import { Typography } from '@equinor/eds-core-react'

export const DashboardPageContainer = styled.div<{ $fitViewport?: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #f7f7f7;
    min-height: 100%;

    @media (max-width: 1024px) {
        padding: 4px;

        /* Pin to the viewport so the child panel scrolls internally instead of overflowing the page. */
        ${({ $fitViewport }) =>
            $fitViewport &&
            css`
                box-sizing: border-box;
                height: 100%;
                min-height: 0;
            `}
    }
`

export const Header = styled.div`
    flex-direction: column;
    margin-bottom: 10px;

    @media (max-width: 1024px) {
        margin-bottom: 0px;
        margin-top: 4px;
    }
`

export const Title = styled(Typography)`
    margin-bottom: 15px;
`

export const Subheading = styled(Typography)`
    margin-bottom: 0px;
`

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    margin: 0 0 1rem 0;
    align-items: center;
    gap: 1rem;
`

export const OnboardingMenuInput = styled.div`
    width: 10rem;
    padding: 0.5rem;
    border-radius: 4px;
`
